<template>
	<div
		class="c-ProgressBar"
		:style="{ height: `${height}px` }"
		:class="progressBarClassObj">
		<div class="c-ProgressBar__bg"></div>
		<div
			v-if="!isIndeterminate"
			:style="{ width: `${progress}%` }"
			class="c-ProgressBar__determinateProgress"></div>
		<div
			v-if="isIndeterminate"
			class="c-ProgressBar__indeterminateProgress increase"></div>
		<div
			v-if="isIndeterminate"
			class="c-ProgressBar__indeterminateProgress decrease"></div>
	</div>
</template>

<script>
export default {
	name: 'ProgressBar',
	props: {
		/**
     * If the Progress Bar type is Indeterminate or Determinate
     * @values true, false
     */
		isIndeterminate: {
			type: Boolean,
			required: false,
			default: () => true
		},
		/**
     * The Progress Bar height in px
     */
		height: {
			type: Number,
			required: false,
			default: () => 4
		},
		/**
     * If The Progress Bar is Determinate, this value is the progress in %
     */
		progress: {
			type: Number,
			required: false,
			default: () => 0,
			validator (val) {
				return val >= 0 && val <= 100
			}
		}
	},
	computed: {
		progressBarClassObj () {
			return {
				isIndeterminate: this.isIndeterminate
			}
		}
	}
}
</script>

<style lang="scss" scoped>
@import '../../scss/variables.scss';

.c-ProgressBar {
  width: 100%;
  overflow-x: hidden;
  position: relative;

  &.isIndeterminate {
    .c-ProgressBar__bg {
      width: 150%;
    }
  }

  &__bg {
    position: absolute;
    background: rgba(162, 167, 238, 0.24);
    width: 100%;
    height: 100%;
    border-radius: 2px;
  }

  &__determinateProgress {
    position:absolute;
    background:#a2a7ee;
    border-radius: 2px;
    height: 100%;
    transition: width $default-time $default-easing;
  }

  &__indeterminateProgress {
    position:absolute;
    background:#a2a7ee;
    border-radius: 2px;
    height: 100%;

    &.increase {
      animation: increase 2s infinite;
    }
    &.decrease {
      animation: decrease 2s 0.5s infinite;
    }
  }

  @keyframes increase {
    from { left: -5%; width: 5%; }
    to { left: 130%; width: 100%;}
  }
  @keyframes decrease {
    from { left: -80%; width: 80%; }
    to { left: 110%; width: 10%;}
  }
}
</style>
